import { Flex, styled } from '@grupoboticario/flora-react';

import { Card } from 'components';

const styles = {
  Card: styled(Card, {
    width: '100%',
    padding: '$4',
  }),

  Divider: styled('hr', {
    margin: '$4 0',
    border: 'solid 1px $backgroundSecondary',
  }),

  Value: styled(Flex, {
    marginBottom: '$4',
  }),

  Heading: styled(Flex, {
    marginBottom: '$4',
    justifyContent: 'left',
  }),
};

export default styles;
